import 'select2/dist/js/select2.full.js'

jQuery('.wppb-select select').select2({
    width: '100%'
})

jQuery('.gform_wrapper .ginput_container_select select, .gform_wrapper .ginput_address_country select').select2({
    width: '100%'
})
